import { Component, Input, NgZone, OnInit, ViewChild, WritableSignal, signal } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { ModalCampaignEmbaddedService } from 'app/campaign/services/modal-campaign-embadded.service';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';

let id = 1;

@Component({
  selector: 'app-shared-link-campaign-popover',
  templateUrl: './shared-link-campaign-popover.component.html',
  styleUrls: ['./shared-link-campaign-popover.component.scss']
})
export class SharedLinkCampaignPopoverComponent implements OnInit {
  
  @ViewChild('popover') popover: MdbPopoverDirective = null;
  
  @Input() campaign: any = null;
  @Input() event: any = null;

  public showEmbedCampaign: WritableSignal<boolean> = signal(true);

  public isModalOpen: boolean = false;
  private _id = id++;
  get id() {
    return `SharedLinkCampaignPopover_${this._id}`;
  }

  constructor(
    private router: Router,
    private popoverService: PopoverService,
    private ngZone: NgZone,
    private modalCampaignEmbaddedService:ModalCampaignEmbaddedService
  ) { }

  ngOnInit(): void {
    if (this.campaign.type === CAMPAIGN_TYPE.AUCTION) {
      this.showEmbedCampaign.set(false);
    }
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  getQRUrl(campaign) {
    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
    const intid = _.get(campaign, 'intid', 0);
    return window.location.protocol + "//" + window.location.hostname + "/@" + handle + "@" + intid;
   
  }

  onCopyToClipboard(campaign) {
    const label = document.getElementById(`share_${campaign.id}`);
    const button = label.parentElement;
    label.innerHTML = 'Copied!';
    button.style.backgroundColor = '#dddddd';
    setTimeout(() => {
      this.ngZone.run(() => {
        label.innerHTML = 'Share';
        button.style.backgroundColor = '#ffffff';
      });
    }, 2000);
  }

  shareFB(campaign) {
    window['FB'].ui({
      method: 'share',
      href: this.getQRUrl(campaign),
      quote: campaign.name,
    }, function(response){});

  }

  shareTwitter(campaign) {
    const url = this.getQRUrl(campaign);
    const href = `https://twitter.com/intent/tweet?text=${campaign.name}&url=${url}&referrer=twitter`
    window.open(href, "_blank");
  }

  getJoinURL(event) {
    let id = null;
    switch(event.type) {
      case 1:
        id = event.virtualEventInfo.id;
        break;
      case 2:
        id = event.hybridEventInfo.virtualEvent.id;
        break;
    }
    return `${window.location.protocol}//${window.location.hostname}/vevent.html?eventId=${id}`;
  }

  goToJOIN(event) {
    const url = this.getJoinURL(event);
    window.open(url, '_blank').focus();
  }

  goToRSVP(event) {
    const url = this.getRSVPURL(event);
    window.open(url, '_blank').focus();
  }

  getRSVPURL(event) {
    return `${this.getJoinURL(event)}&action=openrsvp`;
  }

  shareEventFB(event, rsvp) {
    let name = null;
    switch(event.type) {
      case 1:
        name = event.virtualEventInfo.name;
        break;
      case 2:
        name = event.hybridEventInfo.virtualEvent.name;
        break;
    }
    window['FB'].ui({
      method: 'share',
      href: rsvp ? this.getRSVPURL(event): this.getJoinURL(event),
      quote: name,
    }, function(response){});
  }

  shareEventTwitter(event, type) {
    let name = null;
    let url = '';

    switch (event.type) {
      case 1:
        name = event.virtualEventInfo.name;
        break;
      case 2:
        name = event.hybridEventInfo.virtualEvent.name;
        break;
    }

    switch (type) {
      case 'join':
        url =  this.getJoinURL(event)
        break;
      case 'rsvp':
        url =  this.getRSVPURL(event);
        break;
    }

    const href = `https://twitter.com/intent/tweet?text=${name}&url=${url}&referrer=twitter`
    window.open(href, "_blank");
  }

  onCopyToClipboardEvent(link, event) {
    const id = this.getLinkId(link, event);
    const label = document.getElementById(id);
    const icon: HTMLElement = label.nextElementSibling as HTMLElement;
    const button = label.parentElement;
    label.innerHTML = 'Copied!';
    label.style.color = '#37373c';
    icon.style.color = '#37373c';
    button.style.backgroundColor = '#dddddd';
    setTimeout(() => {
      this.ngZone.run(() => {
        label.innerHTML = `${link} Link`;
        label.style.color = '#ffffff';
        icon.style.color = '#ffffff';
        button.style.backgroundColor = '#37373c';
      });
    }, 2000);
  }
  
  getLinkId(link, event) {
    switch(event.type) {
      case 1:
        return `${link}_${event.virtualEventInfo.id}`;
      case 2:
        return `${link}_${event.hybridEventInfo.virtualEvent.id}`;
    }
    return `${link}_undefined`;
  }

  onClickReport(event, type) {
    switch(event.type) {
      case 0:
        this.router.navigateByUrl(`/event/in-person/${event.inPersonEventInfo.id}/report`)
        break;
      case 1:
        this.router.navigateByUrl(`/event/virtual/${event.virtualEventInfo.id}/report`)
        break;
      case 2:
        if(type === 0) {
          this.router.navigateByUrl(`/event/in-person/${event.hybridEventInfo.inPersonEvent.id}/report`)
        } else if (type === 1) {
          this.router.navigateByUrl(`/event/virtual/${event.hybridEventInfo.virtualEvent.id}/report`)
        }
    }
  }

  onEmbeddedClick(campaign){
    this.isModalOpen = true;

    const handle = _.get(window['localOrgData'], 'user.handle', 'handle');

    const modalRef = this.modalCampaignEmbaddedService.open( handle, campaign);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalCampaignEmbaddedService.modalRef = null;
      this.isModalOpen = false;
    })
  }
}


